/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, Typography, IconButton } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import { makeStyles } from '@material-ui/core/styles'
import { COOKIE_CATEGORIES, getCookiePreferences, saveCookiePreferences } from '../../utils/gdprUtils'

const useStyles = makeStyles((theme) => ({
  banner: {
    position: 'fixed',
    bottom: 16,
    left: 16,
    right: 16,
    zIndex: 1300,
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: { flexDirection: 'column', alignItems: 'stretch' },
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    '& .MuiButton-root': { minHeight: 44, flexGrow: 1, padding: '8px 12px' },
  },
}))

const defaultPrefs = {
  [COOKIE_CATEGORIES.ANALYTICS]: false,
  [COOKIE_CATEGORIES.FUNCTIONAL]: false,
  [COOKIE_CATEGORIES.MARKETING]: false,
}

function CookieConsent() {
  const classes = useStyles()
  const [showBanner, setShowBanner] = useState(false)
  const [openSettings, setOpenSettings] = useState(false)
  const [prefs, setPrefs] = useState(defaultPrefs)

  useEffect(() => {
    const saved = getCookiePreferences()
    if (!saved) {
      setShowBanner(true)
    } else {
      setPrefs(saved)
    }
  }, [])

  const acceptAll = () => {
    const all = {
      [COOKIE_CATEGORIES.ANALYTICS]: true,
      [COOKIE_CATEGORIES.FUNCTIONAL]: true,
      [COOKIE_CATEGORIES.MARKETING]: true,
    }
    saveCookiePreferences(all)
    setPrefs(all)
    setShowBanner(false)
  }

  const rejectAll = () => {
    const none = { ...defaultPrefs }
    saveCookiePreferences(none)
    setPrefs(none)
    setShowBanner(false)
  }

  const saveSettings = () => {
    saveCookiePreferences(prefs)
    setOpenSettings(false)
    setShowBanner(false)
  }

  return (
    <>
      {showBanner && (
        <Box className={classes.banner} role="dialog" aria-label="Cookie consent">
          <Box>
            <Typography variant="subtitle1">🍪 We use cookies</Typography>
            <Typography variant="body2" color="textSecondary">
              We use essential cookies and, with your consent, analytics and marketing cookies.
            </Typography>
          </Box>
          <Box className={classes.actions}>
            <Button onClick={() => setOpenSettings(true)}>Settings</Button>
            <Button onClick={rejectAll}>Reject All</Button>
            <Button color="primary" variant="contained" onClick={acceptAll}>
              Accept All
            </Button>
          </Box>
        </Box>
      )}

      <IconButton aria-label="Cookie settings" onClick={() => setOpenSettings(true)} style={{ position: 'fixed', bottom: 76, right: 8, zIndex: 1100 }}>
        <SettingsIcon />
      </IconButton>

      <Dialog open={openSettings} onClose={() => setOpenSettings(false)} aria-labelledby="cookie-settings-title">
        <DialogTitle id="cookie-settings-title">Cookie Preferences</DialogTitle>
        <DialogContent>
          <Typography variant="body2" paragraph>
            Essential cookies are always on. Choose your preferences for other categories.
          </Typography>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={!!prefs[COOKIE_CATEGORIES.ANALYTICS]}
                onChange={(e) => setPrefs({ ...prefs, [COOKIE_CATEGORIES.ANALYTICS]: e.target.checked })}
              />
            }
            label="Analytics"
          />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={!!prefs[COOKIE_CATEGORIES.FUNCTIONAL]}
                onChange={(e) => setPrefs({ ...prefs, [COOKIE_CATEGORIES.FUNCTIONAL]: e.target.checked })}
              />
            }
            label="Functional"
          />
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={!!prefs[COOKIE_CATEGORIES.MARKETING]}
                onChange={(e) => setPrefs({ ...prefs, [COOKIE_CATEGORIES.MARKETING]: e.target.checked })}
              />
            }
            label="Marketing"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSettings(false)}>Cancel</Button>
          <Button color="primary" variant="contained" onClick={saveSettings}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CookieConsent


